export default "__VITE_ASSET__BE$2Dtb8__"